import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { tile } from '../styles.module.css';
import {
  imageTile,
  title as titleStyle,
  imageContainer,
} from './styles.module.css';

const ImageTile = ({ title, image, link, onClick = () => {} }) => {
  return (
    <Link onClick={onClick} to={link} className={classnames(tile, imageTile)}>
      <div
        className={imageContainer}
        style={{ backgroundImage: `url(${image})` }}
      >
        <span className={titleStyle}>{title}</span>
      </div>
    </Link>
  );
};

export default ImageTile;
